<template>
  <header
    class="w-full h-16 bg-[#512851] text-white flex justify-between items-center"
  ><div class="w-full max-w-[2150px] relative mx-auto">
    <a href="https://www.charlesetalice.fr/" target="_blank"
      ><img
        src="@/assets/images/logo.png"
        alt="logo"
        class="absolute top-1 sm:top-4 left-4 sm:left-[7%] w-[45%] sm:w-[30%] lg:w-[12%] z-40 max-w-[250px]"
    /></a>
    <div
      class="w-full text-right text-white text-2xl lg:text-xl pr-6 fond-bold max-w-[1920px] mx-auto "
    >
      <router-link to="/">Accueil</router-link>
    </div>
    <!-- <i @click="toggle" class="fa-solid fa-bars absolute text-xl z-50"></i> -->
    <div class="relative">
      <Teleport to="body">
        <Drawer @close="toggle" align="right" :closeable="true">
          <div v-if="open"></div>
        </Drawer>
      </Teleport>
    </div>
    </div>
  </header>
</template>
<script>
import Drawer from "vue-simple-drawer";
import Teleport from "vue2-teleport";

export default {
  name: "header-view",
  components: {
    Drawer,
    Teleport,
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>
